"use client"

import { useEffect } from "react"
import Image from "next/image"
import Link from "next/link"
import * as Sentry from "@sentry/nextjs"
import { Home, RefreshCw } from "lucide-react"
import ButtonSupport from "@/components/ButtonSupport" 

export const metadata = {
  title: "Error | Animal Detect",
  robots: { index: false, follow: false },
}

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <section className="h-screen w-full flex flex-col justify-center items-center text-center p-6">
      <Image 
        src="/images/error_page_squirrel.webp"
        alt="Error"
        className="w-96 h-auto"
        width={384}
        height={384}
        priority
      />
      <p className="font-medium md:text-2xl md:font-semibold pt-8 pb-2">
        Something went wrong
      </p>
      <p className="text-error-foreground">{error?.message}</p>

      <div className="flex flex-wrap gap-4 justify-center pt-8">
        <button className="btn-primary gap-2" onClick={() => window.location.reload()}>
          <RefreshCw className="size-4" />
          Refresh Page
        </button>
        <Link href="https://www.animaldetect.com" className="flex flex-wrap btn-secondary gap-2">
          <Home className="size-4" />
          Home
        </Link>
        <ButtonSupport className="btn-secondary"/>
      </div>
    </section>
  )
}